import z from 'zod';
export const EmailSchema = z.string().regex(/^[\w-+\.]+@([\w-]+\.)+[\w-]{1,63}$/, "Not a valid email format");